import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";

import {
  AbstractControl,
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators,
} from "@angular/forms";
import {
  FormFieldType,
  FormQuestion,
} from "../../admin/events-screen/event-page-models/form-question";
import { SelectMenuOption } from "../select-menu/select-menu.component";
import { Observable } from "rxjs/Observable";
import { EventFormDynamicField } from "../../admin/events-screen/event-page-models/event-form-dynamic-field";
import { Subject } from "rxjs/Subject";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "generic-form",
  templateUrl: "./generic-form.component.html",
  styleUrls: ["./generic-form.component.scss"],
})
export class GenericFormComponent implements OnInit, OnDestroy {
  public readonly FormFieldType = FormFieldType;
  @Input("formQuestions") public formQuestions: FormQuestion[];
  @Input("dynamicFormField") public dynamicFormField;
  public dynamicFormFieldStatus: Observable<EventFormDynamicField[]>;
  public genericFormGroup: FormGroup | null = null;
  private readonly destroy$ = new Subject<void>();
  private readonly uniqFormId;

  constructor(private inputFormGroup: FormGroupDirective) {
    this.uniqFormId = Math.floor(Math.random() * 1000);
  }

  public static buildFormGroup(formQuestions: FormQuestion[]): FormGroup {
    const newFields: { [key: string]: FormControl } = {};
    if (formQuestions === null) {
      return new FormGroup({});
    }
    for (const question of formQuestions) {
      const control = { value: "", validaors: [] };
      newFields[question.fieldName] = new FormControl("");

      if (question.value != null) {
        control.value = question.value;
      }

      if (question.fieldType === FormFieldType.Select) {
        if (question.value) {
          question.selectedOption = question.selectItems.find(
            (item) => item.key === question.value
          );
        }
        if (!question.selectedOption) {
          question.selectedOption = question.selectItems[0];
        }
        newFields[question.fieldName].setValue(question.value);
      }

      newFields[question.fieldName] = new FormControl(
        control.value,
        control.validaors
      );
      if (this.isDisabled(question)) {
        newFields[question.fieldName].disable();
      }
    }

    return new FormGroup(newFields);
  }

  public static isDisabled(element: FormQuestion) {
    return element.customAttributes && element.customAttributes.alwaysDisabled;
  }

  @HostListener("wheel", ["$event"])
  public onMousewheel(event) {}

  public ngOnInit(): void {
    this.genericFormGroup = this.inputFormGroup.form;
    if (this.dynamicFormFieldStatus) {
      this.dynamicFormFieldStatus
        .pipe(takeUntil(this.destroy$))
        .subscribe((changes) =>
          this.handleFormEventDynamicFieldChanges(changes)
        );
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public shouldHideField(fieldName: FormQuestion, formField: AbstractControl) {
    return (
      (fieldName.customAttributes &&
        fieldName.customAttributes.hideIfNoValue &&
        !formField.value) ||
      (fieldName.customAttributes && fieldName.customAttributes.alwaysHide)
    );
  }

  public buildUniqId(id: string) {
    return `${id}_${this.uniqFormId}`;
  }

  public getFormField(formGroup: AbstractControl | null, fieldName: string) {
    if (formGroup === null) {
      return null;
    }
    return formGroup.get(fieldName);
  }

  public buildSelectOptions(
    selectItems: Array<{ key: string; value: string }>
  ): SelectMenuOption[] {
    const options = selectItems.map((item) => ({
      key: item.key,
      icon: "",
      text: item.value,
      customValue: "",
    }));

    return options;
  }

  public disableWheelOnNumberInput($event: WheelEvent) {}

  private handleFormEventDynamicFieldChanges(fields: EventFormDynamicField[]) {}
}



// WEBPACK FOOTER //
// ./src/app/form/generic-form/generic-form.component.ts